import * as children from './features/**/routes.js';

export default {
  path: 'order',
  name: 'order',
  children,
  redirect: {
    name: 'transactions',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/index.js